import { ModalProps } from "antd";
import Modal from "components/Utility/Modal/Modal";
import { Device } from "models/Device";
import React from "react";
import { formatDateTime } from "helpers/date-time";
import "./DeviceDetailModal.scss";

export function useDeviceDetailModal() {
  const [visible, setVisible] = React.useState(false);
  const [selectedDevice, setSelectedDevice] = React.useState<Device | null>(null);

  const openDeviceDetailModal = React.useCallback((device: Device) => {
    setSelectedDevice(device);
    setVisible(true);
  }, []);

  const closeDeviceDetailModal = React.useCallback(() => {
    setVisible(false);
    setSelectedDevice(null);
  }, []);

  return {
    visible,
    selectedDevice,
    openDeviceDetailModal,
    closeDeviceDetailModal,
  };
}

interface DeviceDetailModalProps extends ModalProps {
  device: Device | null;
  visible: boolean;
  onClose: () => void;
}

export function DeviceDetailModal(props: DeviceDetailModalProps) {
  const { device, visible, onClose } = props;

  if (!device) return null;

  return (
    <Modal
      title={null}
      onCancel={onClose}
      visible={visible}
      width={560}
      visibleFooter={false}
      closable={false}
    >
      <div className="device-detail-modal">
        <div className="device-detail-modal__header">
          <span className="device-detail-modal__title">Chi tiết thiết bị</span>
          <button
            type="button"
            className="device-detail-modal__close"
            onClick={onClose}
          >
            <i className="tio-clear" />
          </button>
        </div>
        <div className="device-detail-modal__body">
          <div className="device-detail-modal__name">
            {device.name || "Không tên"}
          </div>
          <div className="device-detail-modal__badge">
            {device.deviceType?.name || "—"}
          </div>

          <dl className="device-detail-modal__info">
            <div className="device-detail-modal__row">
              <dt>ID thiết bị</dt>
              <dd className="device-detail-modal__mono">{device.id || "—"}</dd>
            </div>
            <div className="device-detail-modal__row">
              <dt>MAC Address</dt>
              <dd className="device-detail-modal__mono">{device.macAddress || "—"}</dd>
            </div>
            <div className="device-detail-modal__row">
              <dt>IP Address</dt>
              <dd className="device-detail-modal__mono">{device.ipAddress || "—"}</dd>
            </div>
            <div className="device-detail-modal__row">
              <dt>Phiên bản Firmware</dt>
              <dd>{device.firmwareVersion || "—"}</dd>
            </div>
            <div className="device-detail-modal__row">
              <dt>Trạng thái</dt>
              <dd>
                <span className={`device-detail-modal__status device-detail-modal__status--${device.statusId === 1 ? "online" : "offline"}`}>
                  {device.statusId === 1 ? "Trực tuyến" : "Ngoại tuyến"}
                </span>
              </dd>
            </div>
            <div className="device-detail-modal__row">
              <dt>Ngày tạo</dt>
              <dd>{formatDateTime(device.createdAt as any) || "—"}</dd>
            </div>
            <div className="device-detail-modal__row">
              <dt>Cập nhật lần cuối</dt>
              <dd>{formatDateTime(device.updatedAt as any) || "—"}</dd>
            </div>
          </dl>
        </div>
      </div>
    </Modal>
  );
}
